module.exports = __webpack_public_path__ + "src/assets/images/pdf_icon.1801aebbe2eb6478dafac9916dd30680.png";